<template>
	<div v-if="show" :class="slideInClass">
		<header class="titled">
			<div>
				<h1 v-if="disclosedData">{{ disclosedData.name }}</h1>
				<h1 v-else-if="pseudonym">{{ pseudonym.label }}</h1>
			</div>
			<div class="close-container">
				<a href="#" @click.prevent="closeFan">
					<Icon icon="close"/>
				</a>
			</div>
		</header>
		<main class="scrollbar-check">
			<VitaContent
				:job-id="jobId"
				:job-profile-id="jobProfile.id"
				:pseudonym-id="pseudonym.id"
				@loaded="loadedVita = true"
				@close="$emit('hidden')"
			>
				<template v-if="withActions && loadedVita" #after-matching-overview>
					<Actions
						ref="actionsTop"
						:job-profile-list-item="jobProfileListItem"
						:job-id="jobId"
						:applicant="applicant"
						:permissions="permissions"
						:initial-exclusion-type="initialExclusionType"
						class="job-list-item-actions on-white-background d-inline-block mb-3"
					/>
				</template>
			</VitaContent>
			<div v-if="withActions && loadedVita" class="mt-4">
				<div class="job-list-item-actions on-white-background">
					<Actions
						ref="actionsBottom"
						:job-profile-list-item="jobProfileListItem"
						:job-id="jobId"
						:applicant="applicant"
						:permissions="permissions"
						:initial-exclusion-type="initialExclusionType"
					/>
				</div>
				<ContactApplicant
					:initial-in-contacting="applicant.communication.hasOngoingConversation"
					:waiting-for-acceptance-message="applicant.communication.waitingForAcceptanceMessage"
					:job-id="jobId"
					:job-profile-id="jobProfile.id"
					:applicant="applicant"
					class="ml-md-5 mt-2 mt-md-0"
					@contacted="contacted"
				/>
			</div>
		</main>
	</div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import Icon from "@/vue/icon/Icon"
import VitaContent from "@/vue/application/job/vita/Content";
import ContactApplicant from "@/vue/communication/ContactApplicant";
import {getClasses} from "@/helper/layout/Fan";
import {OPEN_FAN_KEY} from "@/store/job/vita";
import Actions from "@/vue/customer/job-profile/applicant/Actions.vue";

export default {

	components: {
		Actions,
		ContactApplicant,
		Icon,
		VitaContent,
	},

	data ()
	{
		return {
			loadedVita: false,
		};
	},

	computed: {
		...mapState('job/vita', [
			'show',
			'jobProfileListItem',
			'jobId',
			'applicant',
			'disclosedData',
			'pseudonym',
			'permissions',
			'withActions',
			'onContacted',
			'onFavored',
		]),
		...mapState('job/vita', {
			initialExclusionType: 'exclusionType'
		}),
		...mapState('layout', ['fanLevelClasses']),
		slideInClass ()
		{
			return getClasses({
				fanLevelClasses: this.fanLevelClasses,
				key: OPEN_FAN_KEY,
				extraClasses: ['job-vita-fan']
			});
		},
		jobProfile ()
		{
			return this.jobProfileListItem.jobProfile;
		},
	},

	methods: {
		...mapActions('job/vita', [
			'close'
		]),
		closeFan ()
		{
			Object.assign(this.$data, this.$options.data.apply(this));

			this.close();
		},
		contacted ()
		{
			if (this.onContacted)
			{
				this.onContacted();

				if (this.$refs.actionsTop)
				{
					this.$refs.actionsTop.reloadApplicant();
				}

				if (this.$refs.actionsBottom)
				{
					this.$refs.actionsBottom.reloadApplicant();
				}
			}
		},
	}
}
</script>
